import { Menu, Status } from "~components";
import { useFacebookPixelScripts } from "~features/analytics/useThirdpartyScripts";
import { Detail } from "~features/events/components/EventDetails/EventDetails";
import { useCampaignReportingOpen } from "~hooks/useBroadastCampaignReporting";
import { useGetEventWithAccessControl } from "~hooks/useGetEventWithAccessControl";
import { useEventTrackingCodes } from "~hooks/useEventTrackingCodes";
import { Event, EventKind } from "~graphql/sdk";
import { useIsMobile, useOrganization } from "~hooks";
import { MobileEventHeaderSinglePage } from "~components/common/Menu/menu.EventHeader";
import { useContext } from "react";
import { BaseContext } from "~context";
import { EventJsonLd, EventJsonLdProps } from "next-seo";
import { getImageSrc, getUrl } from "~lib";
import { generateSEODescription } from "~lib/helpers/formatMetaDescriptions";
import { useRouter } from "next/router";

const EventInfoPage = () => {
  const {
    isLoading,
    event,
    error,
    release,
    accessType,
  } = useGetEventWithAccessControl();
  const isMobile = useIsMobile();
  const { isSinglePage } = useContext(BaseContext);
  useCampaignReportingOpen(!isLoading);
  useEventTrackingCodes();

  useFacebookPixelScripts(event?.pixelId);

  const router = useRouter();
  const { organization } = useOrganization();

  let eventJsonLd: EventJsonLdProps = undefined;
  if (event) {
    eventJsonLd = {
      name: event.title,
      startDate: event.startDate,
      endDate: event.endDate,
      location: {
        name: event.venue.name,
        address: {
          addressCountry: event.venue.address.country,
          addressLocality: event.venue.address.city,
          postalCode: event.venue.address.postalCode,
          streetAddress: event.venue.address.line1,
        },
      },
      url: getUrl(organization.slug, true) + router.asPath,
      description: generateSEODescription(event),
      images: [getImageSrc(event.thumbnail, "")],
      eventAttendanceMode:
        event.eventKind === EventKind.Digital
          ? "OnlineEventAttendanceMode"
          : "OfflineEventAttendanceMode",
      organizer: {
        type: "Organization",
        name: organization.name,
        url: getUrl(organization.slug, true),
      },
    };
  }

  return (
    <>
      {!isLoading && event && <EventJsonLd {...eventJsonLd} />}
      <Menu>
        {!isLoading && isMobile && isSinglePage && event && (
          <MobileEventHeaderSinglePage
            event={event as Event}
          ></MobileEventHeaderSinglePage>
        )}
      </Menu>
      <Status loading={isLoading} error={error}>
        <Detail accessType={accessType} event={event} release={release} />
      </Status>
    </>
  );
};

export default EventInfoPage;
